<template>
  <div>
    <div class="perInfo">
      <img :src="headInfo?.avatar" />
      <div>
        <div class="name">{{ headInfo?.name }}</div>
        <div>{{ headInfo?.mobile }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    infoObj: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      headInfo: {},
    };
  },
  computed: {},
  created() {
    this.headInfo =
      JSON.parse(localStorage.getItem("headInfo")) || this.infoObj;
  },
  methods: {},
};
</script>
<style scoped lang="less">
.perInfo {
  display: flex;
  align-items: center;
  font-size: 24px;
  color: #999999;
  .name {
    font-weight: bole;
    font-size: 36px;
    color: #000000;
  }
  img {
    width: 128px;
    height: 128px;
    border-radius: 50%;
    margin-right: 24px;
  }
}
</style>
